
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.34473 5.80186L1.2569 10.8756C1.0902 11.0417 0.820318 11.0415 0.653901 10.8747C0.487613 10.7081 0.488042 10.438 0.65476 10.2717L5.43974 5.49998L0.654588 0.728234C0.487892 0.561946 0.487462 0.292082 0.653729 0.125363C0.737153 0.04179 0.846443 1.90735e-06 0.955734 1.90735e-06C1.06475 1.90735e-06 1.17361 0.0415106 1.25688 0.124504L6.34473 5.19813C6.42501 5.27801 6.47007 5.38672 6.47007 5.49998C6.47007 5.61325 6.42488 5.72183 6.34473 5.80186Z","fill":"#9C9FAA"}})])
          )
        }
      }
    